import ticketusClient from '@/_http/axiosTicketusClient';
import Immutable from 'immutable';
import reframe from 'nike-re-framejs';

export function fetchProfileSavedTickets(offset = 0, limit) {
    return ticketusClient
        .get('tickets/detail/mobile', {
            params: {
                limit: limit,
                type: 'all',
                offset: offset,
                source: 'Saved'
            }
        })
        .then(json => reframe.dispatch(['ticketus/profile-saved/loaded', Immutable.fromJS(json), offset]))
        .catch(() => reframe.dispatch(['ticketus/profile-saved/loaded', Immutable.fromJS([]), offset]));
}

export function deleteSavedTicket(ticketUrn) {
    return ticketusClient.delete(`/saved-ticket/${ticketUrn}`).catch(error => {
        console.log(error);
        return Promise.resolve();
    });
}

export function fetchSavedTicketByNumber(ticketVisualNo) {
    return ticketusClient.get(`public-saved-ticket/mobile/${ticketVisualNo}`);
}

export function searchSavedTicket(ticketVisualNo) {
    if (!ticketVisualNo) {
        return Promise.reject('Empty ticket number');
    }
    return fetchSavedTicketByNumber(ticketVisualNo);
}

export function loadMoreProfileSavedTickets() {
    reframe.dispatch(['ticketus/profile-saved/load-more']);
}
